import React from 'react';
import { CusProductListSizesSectionProps } from '../../cus-product-list.data';

export default function SizesSection({ sizes, selectedValues, onSelectionChange, sizesFilterHeading }: CusProductListSizesSectionProps) {
    const [isCollapsed, setIsCollapsed] = React.useState(false);
    const selectedSet = React.useMemo(() => new Set(selectedValues ?? []), [selectedValues]);

    const toggleSize = (value: string) => {
        const next = new Set(selectedSet);
        next.has(value) ? next.delete(value) : next.add(value);
        onSelectionChange?.(Array.from(next));
    };

    return (
        <section className='bs-product-list-filters__section'>
            <button
                type='button'
                className='bs-product-list-filters__section__title'
                onClick={() => setIsCollapsed(prev => !prev)}
                aria-expanded={!isCollapsed}
            >
                {sizesFilterHeading}
                <span className='bs-product-list-filters__section__title__chevron' aria-hidden='true' />
            </button>
            <div className={`bs-product-list-filters__sizes${isCollapsed ? ' --collapsed' : ''}`}>
                {sizes.map(size => (
                    <button
                        key={size.value}
                        type='button'
                        className={`bs-product-list-filters__sizes__btn${selectedSet.has(size.value) ? ' --selected' : ''}`}
                        onClick={() => toggleSize(size.value)}
                        aria-pressed={selectedSet.has(size.value)}
                    >
                        {size.value}
                    </button>
                ))}
            </div>
        </section>
    );
}
